import { LoadingButton } from "@mui/lab";
import { Box, Divider, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckBox from "../../components/CheckBox";
import {
  LOADING,
  SUCCESS,
  has_video,
  inperson,
  psypact,
  treatment_program,
} from "../../constants/common";
import { useAuth } from "../../contexts/Auth";
import { useBasicInfo } from "../../contexts/BasicInfo";
import { useGeneralProfile } from "../../contexts/Organization";
import { trackClickEvent } from "../../mixpanel";

const ProfileSessionsOffered = () => {
  const { account_type } = useAuth();
  const [state, setState] = useState({
    inperson_session: 0,
    has_video_provided: 0,
    psypact_provider: 0,
  });
  const [error, setError] = useState({ sessions_offered: false });
  const [editStatus, setEditStatus] = useState("");
  const { fetchInfo, data, updateSessionFormat } = useBasicInfo();

  const { fetchFacilityInfo, facilityInfo, updateTPSessionFormat } =
    useGeneralProfile();
  const info = account_type !== treatment_program ? data : facilityInfo;

  useEffect(() => {
    if (account_type !== treatment_program) fetchInfo();
    else fetchFacilityInfo();
  }, [account_type]);

  useEffect(() => {
    if (info) {
      setState({
        inperson_session: info?.info?.inperson_session || 0,
        has_video_provided: info?.info?.has_video_provided || 0,
        psypact_provider: info?.info?.psypact_provider || 0,
      });
    }
  }, [info]);

  const handleCheckBox = (ev) => {
    setState((prev) => ({
      ...prev,
      [ev.target.name]: ev.target.checked ? 1 : 0,
    }));
    if (ev.target.checked) {
      setError((prev) => ({ ...prev, sessions_offered: false }));
    }
  };

  const handleSave = () => {
    const sessionsOffered = [
      "inperson_session",
      "psypact_provider",
      "has_video_provided",
    ].some((session) => state[session] === 1);

    if (!sessionsOffered) {
      setError((prev) => ({ ...prev, sessions_offered: true }));
      return;
    }

    setEditStatus(LOADING);
    const payload = { ...state };
    const updateFunction =
      account_type !== treatment_program
        ? () => updateSessionFormat(payload)
        : () => updateTPSessionFormat(payload, "program-info");

    updateFunction()
      .then(() => {
        setEditStatus(SUCCESS);
      })
      .catch(() => {
        setEditStatus("");
      });
    trackClickEvent("Updated Profile Information", {
      page: "Edit Profile",
      component: "Session Offered",
      button: "Save",
    });
  };

  return (
    <Paper sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
      <Typography variant="h4">Session Format</Typography>
      <Typography variant="body1">
        Select the types of sessions you offer to clients.
      </Typography>
      <Divider />
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <CheckBox
          label={inperson.label}
          name={inperson.value}
          onChange={handleCheckBox}
          checked={Boolean(state.inperson_session)}
          disabled={editStatus === LOADING}
        />
        <CheckBox
          label={has_video.label}
          name={has_video.value}
          onChange={handleCheckBox}
          checked={Boolean(state.has_video_provided)}
          disabled={editStatus === LOADING}
        />
        {error.sessions_offered && (
          <Typography variant="caption" color="error">
            Please select one or more session type.
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <LoadingButton
          variant="contained"
          sx={{ minWidth: 150 }}
          onClick={handleSave}
          loading={editStatus === LOADING}
        >
          Save
        </LoadingButton>
      </Box>
    </Paper>
  );
};

export default ProfileSessionsOffered;
